<template>
<!--コンテンツ-->
<main id="renew2_top">
    <div class="renew2_top">
        <div class="mv" v-if="$site.appFlag!='b' && topflag=='1'">
            <ul class="renew2_flex renew2_sp_flex mv_txtblock" v-if="!$deviceLib.isMobileDevice">
                <li class="mv__txt"><p><span class="mv__green">会員登録</span><span class="mv__small">で</span><br>バックアップ<br>機能</p></li>
                <li class="mv__txt"><p><span class="mv__green">無料</span><span class="mv__small">で</span>履歴書<br>簡単入力</p></li>
                <li class="mv__txt renew2_pc"><p><span class="mv__small">ヤギッシュなら</span><br><span class="mv__green">提出まで</span><br>スムーズ</p></li>
            </ul>
            <div class="mv__toggle renew2_sp">
                <h3>ヤギッシュなら<span>提出までスムーズ</span></h3>
            </div>
        </div>
        <div class="hero renew2_wrapper" v-if="$site.appFlag!='b' && topflag=='1'">
            <div class="renew2_pc">
                <ul class="hero__list renew2_flex">
                    <li class="list_item">
                        <a href="#">
                            <img src="/static/renew2_img/mv/mv_print.png" alt="コンビニプリント">
                            <h3>履歴書を作成する</h3>
                            <p>履歴書、職務経歴書などを作ることができます</p>
                        </a>
                    </li>
                    <li class="list_item">
                        <a href="/quickemailhelp?frm=ptn1a">
                            <img src="/static/renew2_img/mv/mv_quickemail.png" alt="ヤギのメール便">
                            <h3>ヤギのメール便</h3>
                            <p>応募先企業のメールアドレスにそのまま送ることができます</p>
                        </a>
                    </li>
                    <li class="list_item">
                        <a href="/quickmailhelp?frm=ptn1a">
                            <img src="/static/renew2_img/mv/mv_quickmail.png" alt="ヤギの宅配便">
                            <h3>ヤギの宅配便</h3>
                            <p>印刷から郵送まで全て対応いたします</p>
                        </a>
                    </li>
                    <li class="list_item">
                        <a href="/yagiofferhelp?frm=ptn1a">
                            <img src="/static/renew2_img/mv/mv_yagioffer.png" alt="ヤギオファー">
                            <h3>ヤギオファー</h3>
                            <p>あなたの履歴書を見て企業からオファーが届きます</p>
                        </a>
                    </li>
                    <!--<li class="list_item">
                        <a href="">
                            <img src="/static/renew2_img/hero03.png" alt="求人サイト">
                            <h3>求人サイト</h3>
                            <p>履歴書を書く前でも、いつでも求人を探せます</p>
                        </a>
                    </li>-->
                </ul>
            </div>
            <div class="renew2_sp service__slide renew2_wrapper">
                <div class="service__center">
                    <a v-if="mvBanner==1" href="#"><img src="/static/renew2_img/mv/sp_mv_print.png" alt="コンビニプリントもできる"></a>
                    <a v-else-if="mvBanner==2" href="/quickemailhelp?frm=ptn1a"><img src="/static/renew2_img/mv/sp_mv_quickemail.png" alt="メールで送信"></a>
                    <a v-else-if="mvBanner==3" href="/quickmailhelp?frm=ptn1a"><img src="/static/renew2_img/mv/sp_mv_quickmail.png" alt="郵送でも送れる"></a>
                    <a v-else-if="mvBanner==4" href="/yagiofferhelp?frm=ptn1a"><img src="/static/renew2_img/mv/sp_mv_yagioffer.png" alt="ヤギオファー"></a>
                </div>
                <div class="service__iconlist renew2_sp_flex">
                    <img src="/static/renew2_img/top/icon_print.svg" alt="コンビニプリントもできる" @click="mvBanner=1" >
                    <img src="/static/renew2_img/top/icon_quickemail.svg" alt="メールで送信" @click="mvBanner=2">
                    <img src="/static/renew2_img/top/icon_quickmail.svg" alt="郵送でも送れる" @click="mvBanner=3">
                    <img src="/static/renew2_img/top/icon_yagioffer.svg" alt="ヤギオファー" @click="mvBanner=4">
                </div>
            </div>

        </div>
        <div class="mv_ptn2" v-if="topflag=='2'">
            <p class="recommend_line">おすすめ</p>
            <div class="format_block__mv renew2_flex renew2_sp_flex renew2_wrapper">
                <a href="/format/rirekisho_job_change?frm=ptn1b_top" class="format_item">
                    <div class="format_img">
                        <img src="/static/img/formats/rirekisho_job_change.png" alt="フォーマット">
                    </div>
                    <button class="format_btn">履歴書<span class="btn_txt_small">を作成する</span></button>
                </a>
                <a href="/format/shokumukeirekisho?frm=ptn1b_top" class="format_item keirekisyo-mv">
                    <div class="format_img">
                        <img src="/static/img/formats/shokurekisho-min.png" alt="フォーマット">
                    </div>
                    <button class="format_btn">職務経歴書<span class="btn_txt_small">を作成する</span></button>
                </a>
            </div>
            <a href="#selectformat" class="other_format_link">ほかのフォーマットを見る</a>
            <div class="mv">
                <ul class="renew2_flex renew2_sp_flex mv_txtblock">
                    <li class="mv__txt">
                        <p><span class="mv__green">会員登録</span><span class="mv__small">で</span><br>バックアップ<br>機能</p>
                    </li>
                    <li class="mv__txt">
                        <p><span class="mv__green">無料</span><span class="mv__small">で</span>履歴書<br>簡単入力</p>
                    </li>
                    <li class="mv__txt">
                        <p><span class="mv__small">ヤギッシュなら</span><br><span class="mv__green">提出まで</span><br>スムーズ</p>
                    </li>
                </ul>
                <div  class="service__slide renew2_wrapper renew2_sp">
                    <div  class="service__center">
                        <a  href="#"><img  src="/static/renew2_img/mv/sp_mv_print.png"
                                alt="コンビニプリントもできる">
                        </a>
                    </div>
                    <div  class="service__iconlist renew2_sp_flex">
                        <img  src="/static/renew2_img/top/icon_print.svg" alt="コンビニプリントもできる" @click="mvBanner=1">
                        <img  src="/static/renew2_img/top/icon_quickemail.svg" alt="メールで送信" @click="mvBanner=2">
                        <img  src="/static/renew2_img/top/icon_quickmail.svg" alt="郵送でも送れる" @click="mvBanner=3">
                        <img  src="/static/renew2_img/top/icon_yagioffer.svg" alt="ヤギオファー" @click="mvBanner=4">
                    </div>
                </div>
                <div  class="renew2_pc renew2_wrapper">
                    <ul  class="hero__list renew2_flex">
                        <li  class="list_item"><a  href="#"><img 
                                    src="/static/renew2_img/mv/sp_mv_print.png" alt="コンビニプリント">
                            </a>
                        </li>
                        <li  class="list_item"><a  href="/quickemailhelp?frm=ptn1b"><img
                                     src="/static/renew2_img/mv/sp_mv_quickemail.png" alt="ヤギのメール便">
                            </a>
                        </li>
                        <li  class="list_item"><a  href="/quickmailhelp?frm=ptn1b"><img
                                     src="/static/renew2_img/mv/sp_mv_quickmail.png" alt="ヤギの宅配便">
                            </a>
                        </li>
                        <li  class="list_item"><a  href="/yagiofferhelp?frm=ptn1b"><img
                                     src="/static/renew2_img/mv/sp_mv_yagioffer.png" alt="ヤギオファー">
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        
        <div class="renew2_mv_slide" v-if="$site.appFlag!='b' & false">
            <ul>
                <li>
                    <a tabindex="-1">
                        <img src="/static/renew2_img/renew_mv01_20230906.png">
                    </a>
                </li>
            </ul>
        </div>
        <div class="renew2_mv_slide" v-if="$site.appFlag!='b'">
            <ul style="display: flex;">
                <li style="margin-right: 10px;">
                    <a tabindex="-1">
                        <img src="/static/renew2_img/mv/mv20230925.png">
                    </a>
                </li>
                <li class="renew2_pc" style="margin-right: 10px;">
                    <a href="/quickemailhelp?frm=ptn1a" target="_blank">
                        <img src="/static/renew2_img/mv02_20230907.png">
                    </a>
                </li>
                <li class="renew2_pc" style="margin-right: 10px;">
                    <a href="/quickmailhelp?frm=ptn1a" target="_blank">
                        <img src="/static/renew2_img/mv03_20230907.png">
                    </a>
                </li>
                <li class="renew2_pc" style="margin-right: 10px;">
                    <a href="#" >
                        <img src="/static/renew2_img/mv_yagioffer_20240227.png">
                    </a>
                </li>
            </ul>
        </div>


        <div class="format" style="margin-top:5px;" id="selectformat">
            <div class="format__h2" v-if="!$deviceLib.isMobileDevice || $site.appFlag=='b'">
                <h2 class="renew2_top__h2">まずはフォーマットを選んでね</h2>
            </div>
            <p v-if="(!$deviceLib.isMobileDevice || $site.appFlag=='b') && false" class="renew2_wrapper">ブラウザで最後まで作成可能！バックアップ機能（最後まで入力）もあり安心して作成することができます。<br>
                また、一度作成した書類も入力ページに戻ると修正可能です。</p>

            <!--どれを書くの場合-->
            <div class="renew2_wrapper" v-if="$site.appFlag=='b'"> 
                <ul class="format__choice01 renew2_flex renew2_sp_flex">
                    <li v-if="isWhat" class="what choice01_item select" @click="toggleButton" id="click_what">どれを書く？</li>
                    <li v-if="isWhat" class="who choice01_item" @click="toggleButton" id="click_who">だれが書く？</li>
                    <li v-if="isWho" class="what choice01_item " @click="toggleButton" id="click_what">どれを書く？</li>
                    <li v-if="isWho" class="who choice01_item select" @click="toggleButton" id="click_who">だれが書く？</li>
                </ul>
            </div>
            <ul v-if="isWhat" class="format__choice02 renew2_flex renew2_sp_flex renew2_wrapper">
                <li :class="getSelectedKind('choice02_item', '')" @click="searchKind('')" style="cursor: pointer;" id="click_what_all">すべて</li>
                <li :class="getSelectedKind('choice02_item', '履歴書')" @click="searchKind('履歴書')" style="cursor: pointer;" id="click_what_rirekisho">履歴書</li>
                <li :class="getSelectedKind('choice02_item', '職務経歴書')" @click="searchKind('職務経歴書')" style="cursor: pointer;" id="click_what_keirekisho">職務経歴書</li>
                <li :class="getSelectedKind('choice02_item', '送付状')" @click="searchKind('送付状')" style="cursor: pointer;" id="click_what_souhu">送付状</li>
            </ul>
            <ul v-else class="format__choice02 renew2_flex renew2_sp_flex renew2_wrapper">
                <li :class="getSelectedHash('choice02_item', '')" @click="searchHash('')" style="cursor: pointer;" id="click_who_all">すべて</li>
                <li :class="getSelectedHash('choice02_item', '転職')" @click="searchHash('転職')" style="cursor: pointer;" id="click_who_Job-change">転職</li>
                <li :class="getSelectedHash('choice02_item', '学生')" @click="searchHash('学生')" style="cursor: pointer;" id="">新卒・学生</li>
                <li v-if="false" :class="getSelectedHash('choice02_item', '学生')" @click="searchHash('学生')" style="cursor: pointer;" id="click_who_student">学生</li>
                <li :class="getSelectedHash('choice02_item', 'パート')" @click="searchHash('パート')" style="cursor: pointer;" id="click_who_part-time">パート</li>
            </ul>

            <!--誰が書くの場合
            <div class="renew2_wrapper">
                <ul class="format__choice01 renew2_flex renew2_sp_flex">
                    <li class="what choice01_item">どれを書く？</li>
                    <li class="who choice01_item select">だれが書く？</li>
                </ul>
            </div>
            <ul class="format__choice02 renew2_flex renew2_sp_flex renew2_wrapper">
                <li class="choice02_item select"><a href="">すべて</a></li>
                <li class="choice02_item"><a href="">転職</a></li>
                <li class="choice02_item"><a href="">新卒</a></li>
                <li class="choice02_item"><a href="">学生</a></li>
                <li class="choice02_item"><a href="">パート</a></li>
            </ul>-->

            <div class="format_block">
                <div class="renew2_wrapper">
                    <div id="rirekisyo_format" class="rirekisyo" v-if="!(selectedKind == '送付状' || selectedKind == '職務経歴書')">
                        <div class="renew2_flex renew2_sp_flex format_block__list01" >
                            <h3>履歴書</h3>
                            <ul class="renew2_flex renew2_sp_flex category" v-if="isWhat && (selectedKind == '履歴書' || selectedKind == '')">
                                <li :class="getSelectedHash('category_item', '')" @click="searchHash('')" style="cursor: pointer;" id="csub_lick_who_all">すべて</li>
                                <li :class="getSelectedHash('category_item', '転職')" @click="searchHash('転職')" style="cursor: pointer;" id="sub_click_who_job-change">転職</li>
                                <li :class="getSelectedHash('category_item', '学生')" @click="searchHash('学生')" style="cursor: pointer;" id="sub_click_who_student">新卒・学生</li>
                                <li :class="getSelectedHash('category_item', 'パート')" @click="searchHash('パート')" style="cursor: pointer;" id="sub_click_who_part-time">パート</li>
                            </ul>
                        </div>
                        <div class="format_block__list02 renew2_flex renew2_sp_flex">
                            <a :href="getLink(f.id)"
                              :key="f.id"
                              :id="'toplnk_'+f.id"
                              :target="getTarget(f.id)"
                              v-for="f in forSearchHashs"
                              class="format_item">
                                <div class="format_img" v-if="f.id != 'line_yagibot'">
                                    <img :src="f.thumbnail" :alt="f.title + 'テンプレート'">
                                    <!-- <img src="/static/renew2_img/rirekisho_job_change.png" :alt="f.title + 'テンプレート'"> -->
                                </div>
                                <div class="format_img" style="height: 150px;" v-else>
                                    <img :src="f.thumbnail" :alt="f.title + 'テンプレート'" class="know-how_thumb">
                                    <!-- <img src="/static/renew2_img/rirekisho_job_change.png" :alt="f.title + 'テンプレート'"> -->
                                </div>
                                <div class="format_txt" v-if="f.id != 'line_yagibot'">
                                    <div class="renew2_flex renew2_sp_flex memo">
                                        <p>A4</p>
                                        <p>{{ f.pagenumbs }}</p>
                                    </div>
                                    <h3 class="h3">{{ f.title }}</h3>
                                    <p class="txt">{{ f.newdetail }}</p>
                                </div>
                                <div class="format_txt" style="height: 55px;display: flex;align-items: center;" v-else>
                                    <p class="txt">{{ f.newdetail }}</p>
                                </div>
                                <button v-if="f.id != 'line_yagibot'" class="format_btn">この履歴書でつくる</button>
                                <button v-else class="format_btn know-how_link">LINEで作る</button>
                            </a>
                        </div>
                    </div>
                    <div id="keirekisyo_format" class="keirekisyo" v-if="(isWho && selectedHash == '転職') || (isWhat && (selectedKind == '職務経歴書' || selectedKind == ''))">
                        <div class="renew2_flex renew2_sp_flex format_block__list01">
                            <h3>職務経歴書</h3>
                            <ul class="renew2_flex renew2_sp_flex category">
                                <li class="category_item select">すべて</li>
                            </ul>
                        </div>
                        <p class="print_memo">※コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応</p>
                        <div class="format_block__list02 renew2_flex renew2_sp_flex">


                            <a :href="'/format/'+f.id+'?frm='+top_pattern"
                              :key="f.id"
                              v-for="f in $site.keirekishoFormatsIndex"
                               class="format_item">
                                <div class="format_img">
                                    <img :src="f.thumbnail" :alt="f.title + 'テンプレート'">
                                </div>
                                <div class="format_txt">
                                    <div class="renew2_flex renew2_sp_flex memo">
                                        <p>A4</p>
                                    </div>
                                    <h3 class="h3">{{ f.title }}</h3>
                                    <p class="txt">{{ f.newdetail }}</p>
                                </div>
                                <button class="format_btn" style="background-color:#E95B10">この経歴書でつくる</button>
                            </a>
                        </div>
                    </div>
                    <div id="letter_format" class="letter format_block" v-if="(isWho && selectedHash != 'パート') || (isWhat && (selectedKind == '送付状' || selectedKind == ''))">
                        <div class="renew2_flex renew2_sp_flex format_block__list01">
                            <h3>送付状</h3>
                        </div>
                        <div class="format_block__list02 renew2_flex renew2_sp_flex">


                            <a :href="'/format/'+f.id+'?frm='+top_pattern"
                              :key="f.id"
                              v-for="f in $site.letterFormatsIndex"
                               class="format_item">
                                <div class="format_img">
                                    <img :src="f.thumbnail" :alt="f.title + 'テンプレート'">
                                </div>
                                <div class="format_txt">
                                    <div class="renew2_flex renew2_sp_flex memo">
                                        <p>A4</p>
                                    </div>
                                    <h3 class="h3">{{ f.title }}</h3>
                                </div>
                                <button class="format_btn" style="background-color:#E95B10">送付状をつくる</button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="service renew2_wrapper" v-if="$site.appFlag!='b'">
            <h2 class="renew2_top__h2">ヤギッシュでできること</h2>
            <div class="service__list renew2_flex renew2_sp_flex">
                <img src="/static/renew2_img/service01.png" alt="PDFで出力&メール送信" class="service__item">
                <img src="/static/renew2_img/service02.png" alt="コンビニ印刷" class="service__item">
                <img src="/static/renew2_img/service03.png" alt="バックアップ＆復元" class="service__item">
                <img src="/static/renew2_img/service04.png" alt="自動でブラウザ保存" class="service__item">
                <img src="/static/renew2_img/service05.png" alt="履歴書送付サービス" class="service__item">
                <img src="/static/renew2_img/service06.png" alt="転職相談就職支援" class="service__item">
                <img src="/static/renew2_img/service07.png" alt="推薦書付き履歴書" class="service__item">
                <img src="/static/renew2_img/service08.png" alt="フォント切り替え" class="service__item">
            </div>
            <a href="/info" class="service_btn">ヤギッシュの使い方</a>
        </div>
        <div class="news renew2_wrapper" v-if="false">
            <div class="news__title renew2_flex renew2_sp_flex">
                <h3 class="renew2_top__h3">お知らせ</h3>
                <a href="" class="news__link">お知らせ一覧を見る</a>
            </div>
            <div class="news__block">
                <a href="" class="news__item renew2_flex renew2_sp_flex">
                    <h3 class="title">インターン生募集！</h3>
                    <p class="category">採用情報</p>
                </a>
                <a href="" class="news__item renew2_flex renew2_sp_flex">
                    <h3 class="title">インターン生募集！</h3>
                    <p class="category">採用情報</p>
                </a>
                <a href="" class="news__item renew2_flex renew2_sp_flex">
                    <h3 class="title">インターン生募集！</h3>
                    <p class="category">採用情報</p>
                </a>
            </div>
        </div>
        <div class="tob" v-if="$site.appFlag!='b'">
            <div class="renew2_wrapper tob__block">
                <h3 class="tob__h3">パートナー企業・オフィシャルパートナー<br>（大学）をご検討の方へ</h3>
                <p class="tob__txt">さまざまなユーザーに利用してもらうため、企業様や大学の皆様と連携し、貴社のマーケティング活動に寄り添ったご提案を行います。ぜひお気軽にご相談下さい。</p>
                <ul class="point renew2_flex">
                    <li class="point__item renew2_flex renew2_sp_flex">
                        <img src="/static/renew2_img/point01.png" alt="応募の利便性向上" class="point__img">
                        <p class="point__txt">応募の利便性向上</p>
                    </li>
                    <li class="point__item renew2_flex renew2_sp_flex">
                        <img src="/static/renew2_img/point02.png" alt="老若男女問わず利用" class="point__img">
                        <p class="point__txt">老若男女問わず利用</p>
                    </li>
                    <li class="point__item renew2_flex renew2_sp_flex">
                        <img src="/static/renew2_img/point03.png" alt="ユーザーへの直接のアクション" class="point__img">
                        <p class="point__txt">ユーザーへの直接のアクション</p>
                    </li>
                </ul>
                <a href="https://www.yagish.jp/contact/" target="_blank" class="tob__btn">お問い合わせ</a>
            </div>
        </div>
    </div>
</main>
</template>
<style lang="css" src="@/assets/css/renew2_style.css"></style>
<style lang="css" src="@/assets/css/renew2_top.css"></style>

<style scoped>
@import "/static/css/slick-theme.css";
@import "/static/css/slick.css";
</style>
<style scoped>
    #renew2_top .mv_ptn2 .mv:before{
        background-color: transparent;
    }

    #renew2_top .mv_ptn2 .mv::after{
        display: none;
    }

    #renew2_top .mv_ptn2 .recommend_line {
        background: #EEF5E8;
        color: #004D40;
        text-align: center;
        font-weight: bold;
    }

    #renew2_top .mv_ptn2 .format_block__mv {
        width: 768px;
        justify-content: space-around;
        margin-top: 5px;
    }

    #renew2_top .mv_ptn2 .format_block__mv .format_item {
        width: calc(50% - 10px);
        margin-bottom: 10px;
    }

    #renew2_top .mv_ptn2 .format_block__mv .format_item .format_img {
        text-align: center;
        background: #dfdfdf;
        border-radius: 5px 5px 0 0;
        height: 150px;
        overflow: hidden;
    }

    #renew2_top .mv_ptn2 .format_block__mv .format_item .format_img img {
        width: 70%;
        padding-top: 10px;
    }

    #renew2_top .mv_ptn2 .format_block__mv .format_item .format_btn {
        width: 100%;
        padding: 10px;
        border: none;
        font-size: 1rem;
        font-weight: 700;
        color: #fff;
        background: #0f9934;
        border-radius: 0 0 5px 5px;
    }

    #renew2_top .mv_ptn2 .format_block__mv .keirekisyo-mv .format_btn {
        background: #E95B10;
    }

    #renew2_top .mv_ptn2 .format_block__mv .format_item .format_btn .btn_txt_small {
        font-size: 0.7rem;
    }

    #renew2_top .mv_ptn2 .other_format_link {
        display: block;
        color: #0f9934;
        text-align: center;
        font-weight: bold;
    }

    #renew2_top .mv_ptn2 .mv .mv__txt {
        margin-left: 10px;
    }

    #renew2_top .mv_ptn2 .mv .mv__txt {
        width: 150px;
        height: 150px;
    }

    #renew2_top .mv_ptn2 .mv .mv__txt p {
        width: 150px;
    }

    #renew2_top .mv_ptn2 .mv {
        margin-top: 15px;
        margin-bottom: 50px;
        background: #C1EEEE;
    }

    #renew2_top .mv_ptn2 .service__iconlist {
        background: #fff;
        width: 100vw;
        margin-left: calc(-50vw + 50%);
        justify-content: space-around;
        padding-top: 10px;
    }

    @media screen and (max-width: 640px) {
        #renew2_top .mv_ptn2 .format_block__mv .format_item .format_img {
            height: 90px;
        }

        #renew2_top .mv_ptn2 .mv .mv__txt {
            width: 100px;
            height: 100px;
        }

        #renew2_top .mv_ptn2 .mv .mv__txt p {
            width: 100px;
        }
    }
</style>
<style scoped>
    .renew2_mv_slide{
        text-align: center;
        width: 100%;
        margin: 0 auto;
        margin-bottom: 30px;
        padding-right: 15px;
        padding-left: 15px;
    }

    @media screen and (max-width: 640px){
        .renew2_mv_slide{
            max-width: 100%;
            padding: 0 10px;
            margin-bottom: 20px;
        }
    }
</style>
<script>
import blogWidget from '@/components/BlogWidget'
import YagiOmikuji from '@/components/Omikuji'
import Slick from 'vue-slick'
const RECENT_EDIT_SAVE_KEY = 'recentEdit'
export default {
  props: {
    affId: {
      type: String
    },
    oemId: {
      type: String
    }
  },
  components: {
    'blog-widget': blogWidget,
    'yagi-omikuji': YagiOmikuji,
    Slick
  },
  data: function () {
    return {
        oemList: ['kokudo-bl'],
        is_not_midnight: true,
        recentEdit: {
            FormatId: ''
        },
        topflag: '2',
        top_pattern: 'ptn1b',
        isWhat: true,
        isWho: false,
        selectedKind: '',
        selectedHash: '',
        mvBanner:1,
        slickOptions:{
            centerMode: true,
            // centerPadding: '-20px',
            variableWidth: false,
            accessibility: true,
            autoplay: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplaySpeed: 4000,
            asNavFor: '.slider-nav',
            speed: 400 
        },
        slickNavOptions:{
            focusOnSelect: true,
            asNavFor: '.slider-for',
            variableWidth: false,
            slidesToShow: 5,
            centerPadding: '20px',
        }
    }
  },
  methods: {
    searchHash: function(_hash) {
        this.selectedHash = _hash
    },
    searchKind: function(_kind) {
        this.selectedKind = _kind
    },
    getLink: function(f_id) {
        if (f_id == 'line_yagibot') {
            return process.env.VUE_APP_YAGIBOT_URL // 'https://lin.ee/lQ9AmgT' // https://lin.ee/FniFZ1i
        } else if (f_id == 'y') {
            return 'https://portal.yagish.jp/know-how/mid-career_how-to-write/#index2'
        } else {
            return '/format/'+f_id+'?frm='+this.top_pattern
        }
    },
    getTarget: function(f_id) {
        if (f_id == 'line_yagibot') {
            return '_blank'
        } else {
            return ''
        }
    },
    reload: function () {
      location.reload(true)
    },
    recentEditClass: function (format) {
      if (!this.recentEdit) return
      if (this.recentEdit.FormatId === format.id) {
        return {
          'current-edit': true
        }
      }
    },
    loadRecentEdit: function () {
      const app = this
      this.$getItem(RECENT_EDIT_SAVE_KEY, function (err, data) {
        if (err) {
          console.log(err)
        }
        if (data) {
          app.recentEdit = data
        }
      })
    },
    updateRecentEdit: function (data) {
      if (data) {
        this.recentEdit = data
      }
    },
    toggleButton: function () {
        if (this.isWhat) {
        this.isWhat = false
        this.isWho = true
        } else {
        this.isWhat = true
        this.isWho = false
        }
        this.selectedKind = ''
        this.selectedHash = ''
    },
    getSelectedHash:function(classname, val) {
        if (val == this.selectedHash) {
            return classname + ' select'
        } else {
            return classname
        }

    },
    getSelectedKind:function(classname, val) {
        if (val == this.selectedKind) {
            return classname + ' select'
        } else {
            return classname
        }

    }
  },
  computed: {
    forSearchHashs:function() {
        let _rtVal = []
        if (this.selectedHash) {
            for (let obj of this.$site.rirekishoFormatsIndex) {
                for (let _hash of obj.hashs) {
                    if (_hash == this.selectedHash) {
                        _rtVal.push(obj)
                    }
                }
            }
            return _rtVal
        } else {
            return this.$site.rirekishoFormatsIndex
        }
    }
  },
  created: function () {
    // console.error(this.$deviceLib.getUserAgent.substring(0, 190))
    this.loadRecentEdit()
    const now = new Date()
    if (now.getHours() >= 0 && now.getHours() < 6) {
      this.is_not_midnight = false
    }

    if (Math.floor(Math.random() * 2) == 0) {
        this.topflag = '1'
        this.top_pattern = 'ptn1a'
    } else {
        this.topflag = '2'
        this.top_pattern = 'ptn1b'
    }
    this.topflag = '4'
    this.top_pattern = 'ptn2b_list'
    if (this.$site.appFlag == 'b' ) {
        this.topflag = '3'
        this.top_pattern = 'app'
    }
    this.$eventHub.$on('change-recent-edit', this.updateRecentEdit)
    this.$eventHub.$on('reload', this.reload)
  },
  destroyed: function () {
    this.$eventHub.$off('change-recent-edit', this.updateRecentEdit)
    this.$eventHub.$off('reload', this.reload)
  },
  beforeMount: function () {
    console.error(this.affId)
    if (this.affId) {
        console.error(this.affId)
      this.$cookies.config(60 * 60 * 24,'')
      this.$cookies.set('_YAGISH_AFFILIATE_ID', this.affId, null, null, 'yagish.jp')
      this.$cookies.set('_YAGISH_AFFILIATE_ID', this.affId, null, null, 'localhost')
    }
    if ( this.oemList.indexOf(this.oemId) >= 0) {
        console.error(this.oemId)
      this.$cookies.config(60 * 60 * 24,'')
      this.$cookies.set('_YAGISH_OEM_ID', this.oemId, null, null, 'yagish.jp')
      this.$cookies.set('_YAGISH_OEM_ID', this.oemId, null, null, 'localhost')
      this.$cookies.set('_YAGISH_AFFILIATE_ID', this.oemId, null, null, 'yagish.jp')
      this.$cookies.set('_YAGISH_AFFILIATE_ID', this.oemId, null, null, 'localhost')
    }
  }
}
</script>
